(function(){
  function init(root){
    if(!root || root.dataset.ufxInit==='1') return;
    root.dataset.ufxInit='1';
    var els=root.querySelectorAll('.ufx-reveal');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting)e.target.classList.add('is-visible');});},{threshold:.06});
      els.forEach(function(el){io.observe(el);});
    }else{els.forEach(function(el){el.classList.add('is-visible');});}
    setTimeout(function(){els.forEach(function(el){el.classList.add('is-visible');});},700);
    var rotating=root.querySelector('[data-ufx-rotate]');
    if(rotating){
      var words=(rotating.getAttribute('data-words')||'').split('||').map(function(w){return w.trim();}).filter(Boolean);
      var speed=parseInt(rotating.getAttribute('data-speed'),10)||2200;
      var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(words.length>1&&!reduceMotion){
        var wordIndex=0;
        root._ufxRotateTimer=window.setInterval(function(){
          wordIndex=(wordIndex+1)%words.length;
          rotating.classList.add('is-changing');
          window.setTimeout(function(){
            rotating.textContent=words[wordIndex];
            rotating.classList.remove('is-changing');
          },240);
        },Math.max(900,speed));
      }
    }
    var resultCards=root.querySelectorAll('.ufx-result');
    if(resultCards.length){
      var resultsDuration=parseInt(root.getAttribute('data-results-duration'),10)||1600;
      var reduceResultsMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function metricParts(value){
        var s=(value||'').trim();
        var match=s.match(/^([^0-9.-]*)(-?[0-9,.]+)(.*)$/);
        if(!match)return null;
        var number=parseFloat(match[2].replace(/,/g,''));
        if(!isFinite(number))return null;
        var decimals=(match[2].split('.')[1]||'').length;
        return {prefix:match[1],number:number,suffix:match[3],decimals:decimals};
      }
      function formatMetric(parts,value){
        var decimals=parts.decimals;
        var n=Number(value).toFixed(decimals);
        if(decimals===0 && Math.abs(value)>=1000 && !parts.suffix.toUpperCase().includes('K')){
          n=Math.round(value).toLocaleString('en-US');
        }
        return parts.prefix+n+parts.suffix;
      }
      function animateMetric(el,duration){
        if(!el||el.dataset.counted==='1')return;
        var from=metricParts(el.getAttribute('data-count-from'));
        var to=metricParts(el.getAttribute('data-count-to'));
        if(!from||!to){el.textContent=el.getAttribute('data-count-to')||el.textContent;el.dataset.counted='1';return;}
        el.dataset.counted='1';
        var start=null;
        function step(ts){
          if(start===null)start=ts;
          var p=Math.min(1,(ts-start)/duration);
          var eased=1-Math.pow(1-p,3);
          var value=from.number+(to.number-from.number)*eased;
          el.textContent=formatMetric(to,value);
          if(p<1)window.requestAnimationFrame(step);else el.textContent=el.getAttribute('data-count-to');
        }
        window.requestAnimationFrame(step);
      }
      function playResult(card,index){
        if(card.dataset.resultPlayed==='1')return;
        card.dataset.resultPlayed='1';
        card.classList.add('is-result-animating');
        window.setTimeout(function(){
          card.classList.add('is-result-animated');
          animateMetric(card.querySelector('.ufx-count-up'),resultsDuration);
        },index*120);
        window.setTimeout(function(){card.classList.remove('is-result-animating');},resultsDuration+index*120+200);
      }
      if(reduceResultsMotion){
        resultCards.forEach(function(card){
          var count=card.querySelector('.ufx-count-up');
          if(count)count.textContent=count.getAttribute('data-count-to')||count.textContent;
          card.classList.add('is-result-animated');
        });
      }else if('IntersectionObserver' in window){
        var resultObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              resultCards.forEach(function(card,index){playResult(card,index);});
              resultObserver.disconnect();
            }
          });
        },{threshold:.14});
        resultObserver.observe(root);
      }else{
        resultCards.forEach(function(card,index){playResult(card,index);});
      }
    }

    var visual=root.querySelector('[data-ufx-hero-visual]');
    var store=root.querySelector('.ufx-store');
    if(visual&&store){
      visual.addEventListener('pointermove',function(e){
        if(window.innerWidth<799)return;
        var r=visual.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
        store.style.animation='none';store.style.transform='perspective(1100px) rotateY('+(x*7-4)+'deg) rotateX('+(y*-5+1)+'deg) translateY(-6px)';
      });
      visual.addEventListener('pointerleave',function(){store.style.transform='';store.style.animation='';});
    }
  }
  function boot(){document.querySelectorAll('[data-ufx-section]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',function(e){
    var root=e.target&&e.target.matches&&e.target.matches('[data-ufx-section]')?e.target:null;
    if(root&&root._ufxRotateTimer)window.clearInterval(root._ufxRotateTimer);
  });
})();